import API_CLIENT from "../../utils/Api";

export async function GetUserReport(page) {
  return await API_CLIENT.get(`/users/customer-report?page=${page}`);
}

export async function GetUsersOverview() {
  return await API_CLIENT.get("/users/overview");
}
